export const FETCH_NEWS_REQUEST = 'news/FETCH_NEWS_REQUEST';
export const FETCH_NEWS_SUCCESS = 'news/FETCH_NEWS_SUCCESS';
export const FETCH_NEWS_FAILURE = 'news/FETCH_NEWS_FAILURE';
